export const environment = {
  envName: 'staging' as 'development' | 'staging' | 'production',
  production: true,
  apiUrl: ''  // Le web.config redirige /api/* vers le backend
};
